<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <leaves-admin-header :title="title" :path="path" :text="text" :text1="text1" />
      <!-- /Page Header -->

      <!-- Leave Statistics -->
      <div class="row">
        <div class="col-md-3 d-flex">
          <div class="stats-info w-100">
            <h6>Today Presents</h6>
            <h4>{{ present }} / {{ activeUsersCount }}</h4>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="stats-info w-100">
            <h6>Planned Leaves</h6>
            <h4>{{ plannedLeavesCounts }} <span>Today</span></h4>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="stats-info w-100">
            <h6>Unplanned Leaves</h6>
            <h4>{{ usersWithWorkingDay - present }} <span>Today</span></h4>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="stats-info w-100">
            <h6>Pending Requests</h6>
            <h4>{{ pendingLeavesCounts }}</h4>
          </div>
        </div>
      </div>
      <!-- /Leave Statistics -->

      <!-- Search Filter -->
      <leaves-search-filter @searchClicked="searchClicked"></leaves-search-filter>
      <!-- /Search Filter -->

      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; userLeaves()" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div class="table-responsive">
            <a-table class="stripped table-hover" :columns="columns" :data-source="userLeavesData" :pagination="false" :scroll="{ x: 1520 }">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'name'">
                  <action-dropdown @banked-time="bankedTimeClicked" :employee="{...record, id: record.user_id}" variant="text" :reportAsEvent="true" @edit="editClicked" @leaves="leavesClicked"
                    @attendance="attendanceClicked" @sick-leave="sickLeaveClicked" @add-face-template="addFaceTemplateClicked" @face-templates="faceTemplatesClicked" @report="viewReport" @reset-password="resetPasswordClicked" @assign-employee="assignEmployeeClicked" />
                </template>
                <template v-if="column.key === 'leave_master_category_id'">
                  <h6 class="table-avatar">

                    {{ getCategoriesName(record.leave_master_category_id) }}
                  </h6>
                </template>
                <template v-else-if="column.key === 'status'">
                  <div class="text-center">
                    <div class="action-label">
                      <a class="btn btn-white btn-sm btn-rounded" href="javascript:void(0);">
                        <i :class="record.class"></i>
                        {{ record.status }}
                      </a>
                    </div>
                    <!--                      <div class="dropdown action-label">-->
                    <!--                        <a-->
                    <!--                          class="btn btn-white btn-sm btn-rounded dropdown-toggle"-->
                    <!--                          href="javascript:;"-->
                    <!--                          data-bs-toggle="dropdown"-->
                    <!--                          aria-expanded="false"-->
                    <!--                          @click="updateStatus(record.id, record.status)"-->
                    <!--                        >-->
                    <!--                          <i :class="record.class"></i> {{ record.status }}-->
                    <!--                        </a>-->
                    <!--                        <div class="dropdown-menu dropdown-menu-right">-->
                    <!--                          <a class="dropdown-item" href="javascript:;"-->
                    <!--                            ><i class="fa-regular fa-circle-dot text-purple"></i> Hold</a-->
                    <!--                          >-->
                    <!--                          <a class="dropdown-item" href="javascript:;"-->
                    <!--                            ><i class="fa-regular fa-circle-dot text-info"></i> Pending</a-->
                    <!--                          >-->
                    <!--                          <a-->
                    <!--                            class="dropdown-item"-->
                    <!--                            href="javascript:;"-->
                    <!--                            data-bs-toggle="modal"-->
                    <!--                            data-bs-target="#approve_leave"-->
                    <!--                            ><i class="fa-regular fa-circle-dot text-success"></i>-->
                    <!--                            Approved</a-->
                    <!--                          >-->
                    <!--                          <a class="dropdown-item" href="javascript:;"-->
                    <!--                            ><i class="fa-regular fa-circle-dot text-danger"></i>-->
                    <!--                            Rejected</a-->
                    <!--                          >-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                  </div>
                </template>
                <template v-else-if="column.key === 'Approvedby'">
                  {{ record.updated_by_user ? (record.updated_by_user.first_name + ' ' + record.updated_by_user.last_name) : (record.status_updated_by ? record.status_updated_by : '--') }}
                </template>
                <template v-else-if="column.key === 'status_updated_at'">
                  {{ record.status_updated_at ? formatDateTimeStandardWithTime(record.status_updated_at) : (record.updated_at ? formatDateTimeStandardWithTime(record.updated_at) : '--') }}
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="text-end">
                    <div class="dropdown dropdown-action">
                      <a href="javascript:void(0);" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a v-if="isSicknessCategory(record.leave_master_category_id)" class="dropdown-item" href="javascript:;"
                          data-bs-toggle="modal" data-bs-target="#sick_leave_details_modal" @click="view(record)"><i
                            class="fa-solid fa-eye m-r-5"></i>View Details</a>
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_leave"
                          @click="editClicked(record)"><i class="fa-solid fa-pencil m-r-5"></i> Edit Leave</a>
                        <a class="dropdown-item" href="javascript:;" @click="leavesClicked(record)"><i
                            class="fa-solid fa-bars m-r-5"></i>All Leaves</a>
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#delete_approve" @click="deleteClicked(record.id)"><i
                            class="fa-regular fa-trash-can m-r-5"></i> Delete</a>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
          <div class="d-flex justify-content-center">
            <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="userLeaves"
              show-less-items class="mt-3 " :showSizeChanger="false">
              <template #itemRender="{ type, originalElement }">
                <a v-if="type === 'prev'">Previous</a>
                <a v-else-if="type === 'next'">Next</a>
                <component :is="originalElement" v-else></component>
              </template>
            </a-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <leaves-admin-modal ref="leaveAdmin" @allLeaves="userLeaves"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeave"></sick-leave-details-modal>
    <sick-leave-modal ref="sickLeaveModal"></sick-leave-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="userLeaves"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="userLeaves"></assign-employee-modal>
  </div>
  <!-- /Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import { Modal } from "bootstrap";
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../../../config";
import { calcDays, formatDDMMYYYY, statusIconClass, formatUSDate, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
import { dateRangeStart } from "@/utils/util-var";
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";


const columns = [
  {
    title: "Employee",
    dataIndex: "name",
    key: "name",
    width: 240,
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Leave Type",
    dataIndex: "type",
    width: 120,
    sorter: {
      compare: (a, b) => {
        a = a.type.toLowerCase();
        b = b.type.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "leave_master_category_id",
    key: "leave_master_category_id",
    width: 140,
  },
  {
    title: "From",
    dataIndex: "start_date",
    width: 120,
    sorter: {
      compare: (a, b) => {
        a = a.start_date;
        b = b.start_date;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "To",
    dataIndex: "end_date",
    width: 120,
    sorter: {
      compare: (a, b) => {
        a = a.end_date;
        b = b.end_date;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "No of Days",
    dataIndex: "no_of_days",
    width: 110,
    sorter: {
      compare: (a, b) => {
        a = a.no_of_days.toLowerCase();
        b = b.no_of_days.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Reason",
    dataIndex: "reason",
    ellipsis: true,
    width: 140,
    sorter: {
      compare: (a, b) => {
        a = a.reason.toLowerCase();
        b = b.reason.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 130,
    sorter: {
      compare: (a, b) => {
        a = a.status.toLowerCase();
        b = b.status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status Updated by",
    dataIndex: "status_updated_by",
    key: "Approvedby",
    width: 170,
    ellipsis: true,
  },
  {
    title: "Status Updated at",
    dataIndex: "status_updated_at",
    key: "status_updated_at",
    width: 160,
  },
  {
    title: "Action",
    sorter: true,
    key: "action",
    text: "end",
    width: 70,
  },
];

// const d = new Date();
// const dateRangeStart = new Date(d.setMonth(d.getMonth() - 1));
// const dateRangeEnd = new Date();
const today = new Date();
const endOfYear = new Date(today.getFullYear(), 11, 31);
export default {
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  data() {
    return {
      columns,
      title: "Leaves",
      path: "Dashboard",
      text: "Leaves",
      text1: "Add Leave",
      userLeavesData: null,
      perPage: 10,
      current: 1,
      total: 0,
      startDate: formatUSDate(dateRangeStart),
      endDate: formatUSDate(endOfYear),
      employeeName: "",
      leaveType: null,
      leaveStatus: null,
      activeUsersCount: null,
      usersWithWorkingDay: null,
      present: null,
      pendingLeavesCounts: null,
      plannedLeavesCounts: null,
      masterCategoryIds: [],
      plannedLeave: false,
      pendingLeave: false
    };
  },
  methods: {
    formatDateTimeStandardWithTime,
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

    async userLeaves() {
      if (Number(this.perPage) >= this.total) {
        this.current = 1
      }
      await axios.get(`${VUE_APP_API_BASE_URL}/leave/all?page=${this.current}`, {
        params: {
          per_page: this.perPage,
          start_date: this.startDate,
          end_date: this.endDate,
          employee_name: this.employeeName,
          leave_type: this.leaveType,
          status: this.leaveStatus,
        }
      }).then((response) => {

        if (response.data.status) {
          this.userLeavesData = response.data.data.leave_applications.data;
          this.activeUsersCount = response.data.data.active_users_count;
          this.usersWithWorkingDay = response.data.data.users_with_working_day;
          this.present = response.data.data.present;
          this.pendingLeavesCounts = response.data.data.pending_leaves;
          this.plannedLeavesCounts = response.data.data.approved_leaves;
          this.userLeavesData.forEach(element => {
            element["no_of_days"] = calcDays(element["start_date"], element["end_date"]);
            element["start_date_raw"] = element["start_date"];
            element["end_date_raw"] = element["end_date"];
            element["start_date"] = formatDDMMYYYY(element["start_date"]);
            element["end_date"] = formatDDMMYYYY(element["end_date"]);
            element["name"] = element["user"] ? element["user"]["first_name"] + ' ' + element["user"]["last_name"] : '-';
            element["class"] = statusIconClass(element["status"]);
          });
          this.current = response.data.data.leave_applications.current_page;

          this.total = response.data.data.leave_applications.total;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    async getMasterCategories() {
      await axios.get(`${VUE_APP_API_BASE_URL}/master-category`)
        .then((response) => {
          if (response.data.status) {
            this.masterCategoryIds = response.data.data;
            this.masterCategoryIds.forEach(element => {

              element['text'] = element['name'];
              delete element['name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    getCategoriesName(id) {
      const name = this.masterCategoryIds.find(item => item.id === id);
      return name ? name.text : '-';
    },

    isSicknessCategory(id) {
      const category = this.masterCategoryIds.find(item => item.id === id);
      if (!category) return false;
      const name = (category.text || '').toLowerCase();
      return name.includes('sick') || name.includes('ssp') || name.includes('smp') || name.includes('spp');
    },


    view(item) {
      this.$refs.sickLeave.updateValues(item, item.name);
    },

    async updateStatus(id, leaveStatus) {
      await axios.post(`${VUE_APP_API_BASE_URL}/leave/${id}/update`, {
        status: leaveStatus,
      }).then((response) => {
        if (response.data.status) {
          this.$emit("userLeaves");
          this.$toast.success(response.data.data.message);
        }
      }).catch(function (error) {
        console.log('error ', error);
      });
    },
    editClicked(record) {
      this.$refs.leaveAdmin.updateStatus(record);
    },
    deleteClicked(id) {
      this.$refs.leaveAdmin.deleteLeave(id);
    },
    searchClicked(data) {
      this.startDate = data.start_date;
      this.endDate = data.end_date;
      this.employeeName = data.employee_name;
      this.leaveStatus = data.leave_status;
      this.leaveType = data.leave_type;
      this.current = 1;
      this.userLeaves();
    },

    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.user_id } });
      window.open(routeData.href, '_blank');
    },
    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.user_id } });
      window.open(routeData.href, '_blank');
    },
    sickLeaveClicked(record) {
      this.$refs.sickLeaveModal.updateValues(record);
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },
    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },
  },
  mounted() {
    this.plannedLeave = this.$route.query.plannedLeave;
    this.pendingLeaves = this.$route.query.pendingLeave;
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);


    if (this.plannedLeave) {

      const day = String(tomorrow.getDate()).padStart(2, '0');
      const month = String(tomorrow.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const year = tomorrow.getFullYear();
      let formattedDate = `${day}-${month}-${year}`;
      this.leaveStatus = 'APPROVED',
        this.startDate = formattedDate
    }
    if (this.pendingLeaves) {
      this.leaveStatus = 'PENDING'
    }
    this.userLeaves();
    this.getMasterCategories();

  }
};
</script>
<style scoped>
.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

/* Fix for dropdown menu being clipped by table-responsive overflow */
.table-responsive {
  overflow-x: auto !important;
  overflow-y: visible !important;
}
</style>